import { render, staticRenderFns } from "./AdGroupAd.vue?vue&type=template&id=ced89ffe&scoped=true&lang=pug&"
import script from "./AdGroupAd.vue?vue&type=script&lang=js&"
export * from "./AdGroupAd.vue?vue&type=script&lang=js&"
import style0 from "./AdGroupAd.vue?vue&type=style&index=0&id=ced89ffe&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced89ffe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/zx/@sdc/toolkit/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCard,VContainer,VDataTable,VFlex,VIcon,VLayout})
